import React, { useState } from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap';

/**
 * Renderiza um ícone de computador que, quando apos clicado, mostra a lista de filas monitoradas
 * @param {object} props
 * @param {string[]} props.queueNames
 * @param {string} props.iconColor
 */
const MonitoredQueuesList = ({ queueNames = [], iconColor }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggle = () => setIsDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown
      direction="left"
      isOpen={isDropdownOpen}
      toggle={toggle}
      className="mr-2"
    >
      <DropdownToggle
        tag="span"
        data-toggle="dropdown"
        aria-expanded={isDropdownOpen}
      >
        <span style={{ padding: '10px', cursor: 'pointer', color: iconColor }}>
          <i className="fas fa-desktop"></i>
        </span>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem header>Filas Monitoradas</DropdownItem>
        {queueNames.length ? (
          queueNames.map((queue) => (
            <DropdownItem key={queue} toggle={false} tag="span" text>
              {queue}
            </DropdownItem>
          ))
        ) : (
          <DropdownItem tag="span" text>
            Nenhuma fila sendo monitorada
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export { MonitoredQueuesList };
